import { getHashOfString } from "./string"

type AvatarProps = {
  color: string
  backgroundColor: string
  label: string
}

type StringToAvatarOptions = {
  name: string
  colors: Omit<AvatarProps, "label">[]
}

/**
 * Generate the Avatar component props
 */
export const stringToAvatar = ({ name, colors }: StringToAvatarOptions): AvatarProps => {
  // Get avatar colors
  const hash = Math.abs(getHashOfString(name))
  const index = hash % colors.length
  const avatarColors = colors[index]
  if (!avatarColors) throw new Error(`No color found for index ${index}`)

  // Get label
  const firstLetter = name.trim().toUpperCase().charAt(0)
  const label = firstLetter

  return {
    ...avatarColors,
    label,
  }
}
